angular.module("app").controller("FiltersAddPageController", [
    '$scope',
    '$filter',
    'pageStatuses',
    'casinoCategoryService',
    'errorHandler',
    'logger',
    '$stateParams',
    '$uibModalInstance',
    'type',
    'settingsService',
    'preloadedSkins',
    function ($scope, $filter, pageStatuses, casinoCategoryService, errorHandler, logger, $stateParams, $modalInstance, type, settingsService, preloadedSkins) {

        $scope.tooltip = {
            name: "",
            title: ""
        };
        var translator = $filter('translate'),
            settings = settingsService.getSettings();


        var tmpLanguages = [];

        angular.forEach(settings.languages, function (lang) {
            if (lang == 'en') return true;

            tmpLanguages.push({
                id: lang,
                title: lang.toUpperCase() + ' - ' + translator('top_menu.languages.' + lang),
                placeholder: 'Name'
            });
        });

        $scope.skins = angular.copy(preloadedSkins)

        $scope.languages = tmpLanguages;

        $scope.pageStatuses = pageStatuses;

        $scope.save = function () {
            if (!$scope.add_category_form.$valid) {
                $scope.isSavePressed = true;
                return;
            }
            if ($scope.filterData.type === 'category') {
                var addElementHelper = $scope.useAddElementHelper();
                $scope.filterData.translations = addElementHelper.fetchData('categoryTitleTranslation');
            }

            casinoCategoryService.create({casinoCategory: $scope.filterData}).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("saved");
                        init();
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.isForItem = function () {
            return !isNaN(+$stateParams.itemId)
        };

        function init () {
            $scope.filterData = {
                name: "",
                title: "",
                status: pageStatuses[0],
                type: type
            };

            if (type == 'category') {
                $scope.filterData.is_custom = false
                $scope.filterData.skins = []
            }

            $scope.add_category_form && $scope.add_category_form.$setPristine();
        }

        init();

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
]);
